  export const Breadcrumbs = ({
    clinicId,
    studyName,
    siteName,
    userLabel,
    isSiteView,
    isUserView,
    onStudyClick,
    onSiteClick,
  }) => (
    <div className="breadcrumbs">
      <span
        className={`breadcrumb-item ${
          !isSiteView && !isUserView ? "active" : ""
        }`}
        onClick={onStudyClick}
        style={{ cursor: "pointer" }}
      >
        {studyName}
      </span>
      {siteName && (
        <>
          <span className="breadcrumb-separator">→</span>
          <span
            className={`breadcrumb-item site ${isSiteView ? "active" : ""}`}
            onClick={onSiteClick}
            style={{ cursor: isSiteView ? "default" : "pointer" }}
          >
            {siteName}{" "}{`ID: (${clinicId})`}
          </span>
        </>
      )}
      {userLabel && (
        <>
          <span className="breadcrumb-separator">→</span>
          <span className={`breadcrumb-item ${isUserView ? "active" : ""}`}>
            {userLabel}
          </span>
        </>
      )}
    </div>
  );
